import '@/assets/js/mock'; // 引入mock.js
import '@/styles/index.scss';
import '@/styles/theme.less';
import { numberFormat, timeDate,getnull } from '@/utils';
import axios from '@/utils/request';
import MerakUI from '@jd/merak-vue';
import { RestHelper } from '@jd/merak-vue/src/rest/rest-helper';
import FinD from '@weus/fuc-design';
import '@/styles/style.less';//自定义主题色
// 防抖自定义指令
import "@/utils/debounce.js"
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2'
 
import App from './app.vue';
import './config/dretive.js';
import i18n from './i18n';
import router from './router';
import store from './store';
import { noticeTime } from '@/config/utils';
import { validator } from '@/utils/validator'
import bus from '@/utils/bus'
Vue.config.productionTip = false;
Vue.use(MerakUI);
Vue.use(VueCookies);
Vue.use(VueClipboard)

Vue.prototype.$bus = bus
Vue.prototype.$get = getnull
Vue.prototype.$validator = validator

Vue.filter('timeDate', timeDate);
Vue.filter('numberFormat', numberFormat);
Vue.filter('noticeTime', noticeTime);

let authToken = localStorage.getItem('authToken')
if (authToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`
}
RestHelper.client = axios;
Vue.directive('focus', {
  // 指令的定义；当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.querySelector('input').focus()
  }
})

/*
 *@description:'节流指令'
 *@params1: 绑定元素标签
 *@params2: 设置节流时间
*/
Vue.directive('throttle', {
  bind: (el, binding) => {
    let throttleTime = binding.value; // 节流时间
    if (!throttleTime) { // 用户若不设置防抖时间，则默认2s
      throttleTime = 2000;
    }
    let cbFun;
    el.addEventListener('click', event => {
      if (!cbFun) { // 第一次执行
        cbFun = setTimeout(() => {
          cbFun = null;
        }, throttleTime);
      } else {
        event && event.stopImmediatePropagation();
      }
    }, true);
  },
});


const VXETable = window['VXETable']
Vue.use(VXETable)



//这里面的加载顺序不能改！！！  start
import FE from '@jd/magnus-fe-components'
import '@jd/magnus-fe-components/lib/index.css'

Vue.use(FE, { request: axios.request})
Vue.use(FinD, { size: 'medium', zIndex: 3000 });
//这里面的加载顺序不能改！！！  end

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
